/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/DeliveryDelay.js
class DeliveryDelay {
  constructor() {
    this.delayMin = 5;
    this.delayMax = 7;
    this.textIconSelector = ".product-information__text-icon";
    this.firstDateSelector = ".product-information__text-bold-date--first";
    this.secondDateSelector = ".product-information__text-bold-date--second";
    this.holidays = [];
  }

  init = async () => {
    const textIcons = document.querySelectorAll(this.textIconSelector);

    if (!textIcons.length > 0) {
      return;
    }

    const today = new Date();
    const year = today.getFullYear();

    try {
      const response = await fetch(`https://calendrier.api.gouv.fr/jours-feries/metropole/${year}.json`);
      const data = await response.json();
      this.holidays = Object.keys(data).map(date => new Date(date));
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error("Erreur lors du chargement des jours fériés :", error);
    }

    textIcons.forEach(textIcon => {
      const firstDate = textIcon.querySelector(this.firstDateSelector);
      const secondDate = textIcon.querySelector(this.secondDateSelector);

      if (!firstDate || !secondDate) {
        return;
      }

      const options = {
        month: "short",
        day: "numeric",
      };

      const estimatedDate = this.addWorkingDays(today, this.delayMin);
      firstDate.innerText = estimatedDate.toLocaleDateString("fr-FR", options);

      const estimatedDateMax = this.addWorkingDays(today, this.delayMax);
      secondDate.innerText = estimatedDateMax.toLocaleDateString("fr-FR", options);

      textIcon.style.opacity = 1;
    });
  };

  isWorkingDay = date => {
    const day = date.getDay();
    const isWeekend = day === 0 || day === 6; // Sunday = 0, Saturday = 6
    const isHoliday = this.holidays.some(holiday => holiday.toDateString() === date.toDateString());
    return !isWeekend && !isHoliday;
  };

  addWorkingDays = (startDate, daysToAdd) => {
    const date = new Date(startDate);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (this.isWorkingDay(date)) {
        addedDays++;
      }
    }
    return date;
  };
}

;// ./src/js/FooterAxeptio.js
class FooterAxeptio {
  constructor() {
    this.footerLinksSelector = ".footer .widget--menu a";
  }

  init = () => {
    const footerLinks = document.querySelectorAll(this.footerLinksSelector);

    if (!footerLinks.length > 0) {
      return;
    }

    footerLinks.forEach(link => {
      if (link.href.includes("#replaceAxeptio")) {
        // eslint-disable-next-line no-script-url
        link.href = "javascript:openAxeptioCookies()";
        return;
      }
    });
  };
}

;// ./src/js/Header.js
class Header {
  constructor() {
    this.announcementBarSelector = ".announcement-bar-section";
    this.headerSectionSelector = ".header-section";
    this.headerSelector = ".header";
    this.scrollValue = 0;
    this.announcementBarHeight = 0;
    this.headerHeight = 0;
    this.headerTotalHeight = 0;
    this.isHidden = false;
    this.ticking = false;
  }

  init = () => {
    this.announcementBar = document.querySelector(this.announcementBarSelector);
    this.header = document.querySelector(this.headerSectionSelector);
    if (!this.announcementBar || !this.header) {
      return;
    }

    this.announcementBarHeight = this.announcementBar.offsetHeight;
    this.headerHeight = this.header.offsetHeight;
    this.headerTotalHeight = this.announcementBarHeight + this.headerHeight;

    if (this.headerHeight === 0) {
      // Fallback used when header is set to absolute position
      this.headerHeight = document.querySelector(this.headerSelector).offsetHeight;
    }

    this.header.style.top = `${this.announcementBarHeight}px`;
    this.manageHeaderVisibility();
  };

  manageHeaderVisibility = () => {
    document.addEventListener("scroll", this.requestTick, { passive: true });
  };

  requestTick = () => {
    if (!this.ticking) {
      requestAnimationFrame(this.updateHeader);
      this.ticking = true;
    }
  };

  updateHeader = () => {
    const scrollingDown = window.scrollY > this.scrollValue;

    if (window.scrollY > this.headerTotalHeight) {
      if (scrollingDown && !this.isHidden) {
        this.hideHeader();
      } else if (!scrollingDown && this.isHidden) {
        this.showHeader();
      }
    }

    this.scrollValue = window.scrollY;
    this.ticking = false;
  };

  hideHeader = () => {
    this.announcementBar.style.top = `-${this.announcementBarHeight}px`;
    this.header.style.top = `-${this.headerHeight}px`;
    this.isHidden = true;
  };

  showHeader = () => {
    this.announcementBar.style.top = `0px`;
    this.header.style.top = `${this.announcementBarHeight}px`;
    this.isHidden = false;
  };
}

;// ./src/js/PaginationCollection.js
class PaginationCollection {
  constructor() {
    this.totalPages = window.collectionTotalPages;
    this.currentPage = 1;
    this.paginationButtonSelector = ".pagination";
  }

  init = () => {
    const paginationButton = document.querySelector(this.paginationButtonSelector);
    if (!paginationButton) {
      return;
    }

    document.addEventListener("pagination:page-changed", e => {
      this.currentPage = Number(e.detail.url.split("?page=")[1]);
      if (this.currentPage >= this.totalPages) {
        paginationButton.style.display = "none";
      }
    });
  };
}

;// ./src/js/Product.js
class Product {
  constructor() {
    this.productSelector = ".template-product";
    this.subscriberPriceSelector = ".price__subscriber-price";
    this.subscriberPriceValueSelector = ".price__subscriber-price-value";
    this.discountPercentage = 0.1;
    this.discountedPrice = 0;
    this.formattedPrice = null;
  }

  init = () => {
    const product = document.querySelector(this.productSelector);
    if (!product) {
      return;
    }

    const subscriberPrice = product.querySelector(this.subscriberPriceSelector);
    const subscriberPriceValue = product.querySelector(this.subscriberPriceValueSelector);
    if (!subscriberPrice || !subscriberPriceValue) {
      return;
    }

    this.orignalPrice = Number(subscriberPrice.dataset.price);

    document.addEventListener("product:variant-change", e => {
      this.discountedPrice = e.detail.variant.price - e.detail.variant.price * this.discountPercentage;
      this.formattedPrice = this.discountedPrice * 0.01;
      subscriberPriceValue.innerText = `${this.formattedPrice.toFixed(2).replace(".", ",")}€`;
    });
  };
}

;// ./src/main.js






// JS goes here

window.addEventListener("load", () => {
  const classes = [new DeliveryDelay(), new Product(), new FooterAxeptio(), new PaginationCollection(), new Header()];
  classes.forEach(classe => classe.init());
});

/******/ })()
;